module.exports = __webpack_public_path__ + "static/img/gyeongsangnam-do.9626907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapFragment/gyeongsangnam-do.png
// module id = Wgs+
// module chunks = 3